import { CSSProperties } from 'react';

type StatusCardGroupStyles = {
  statusCardGroup: CSSProperties;
};

const styles: StatusCardGroupStyles = {
  statusCardGroup: {
    width: '100%',
    alignItems: 'stretch',
    justifyContent: 'start',
    gap: 'clamp(12px, 4vw, 26px)'
  }
};

export default styles;
